"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALPHA_NUMERIC_ONLY_REGEX = void 0;
exports.ALPHA_NUMERIC_ONLY_REGEX = /^[A-Za-z0-9]*$/;
